import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const PaymentSetupForm = ({ formData, onChange, errors }) => {
  return (
    <div className="space-y-6">
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-6">
        <div className="flex items-start space-x-3">
          <Icon name="CreditCard" size={24} className="text-accent flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-semibold text-foreground mb-2">Enquiry Acceptance Fee</h3>
            <p className="text-sm text-muted-foreground mb-3">
              When you accept a customer enquiry, a £7.00 fee is charged to ensure serious engagement.
              This fee helps maintain quality interactions and covers platform costs.
            </p>
            <div className="bg-card rounded-lg p-4 border border-border">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
                <div>
                  <div className="text-2xl font-bold text-primary mb-1">£7.00</div>
                  <div className="text-xs text-muted-foreground">Per Enquiry Accepted</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-success mb-1">0%</div>
                  <div className="text-xs text-muted-foreground">Commission on Bookings</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-accent mb-1">24/7</div>
                  <div className="text-xs text-muted-foreground">Customer Support</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-primary/10 border border-primary/20 rounded-lg p-6">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={24} className="text-primary flex-shrink-0 mt-1" />
          <div>
            <h3 className="font-semibold text-foreground mb-2">Payment Setup After Approval</h3>
            <p className="text-sm text-muted-foreground">
              You'll add your payment method in Agent Settings once your application is approved and you've been vetted. 
              This ensures secure payment processing only for verified agents.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-card p-6 rounded-lg border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4">Terms & Conditions</h3>
        
        <div className="space-y-4">
          <Checkbox
            label="I agree to the HoliYay Terms of Service"
            description="By checking this box, you agree to our platform terms and conditions"
            checked={formData?.agreeToTerms}
            onChange={(e) => onChange({ target: { name: 'agreeToTerms', value: e?.target?.checked } })}
            error={errors?.agreeToTerms}
            required
          />
          
          <Checkbox
            label="I agree to the Privacy Policy"
            description="You consent to our data processing practices as outlined in our privacy policy"
            checked={formData?.agreeToPrivacy}
            onChange={(e) => onChange({ target: { name: 'agreeToPrivacy', value: e?.target?.checked } })}
            error={errors?.agreeToPrivacy}
            required
          />
          
          <Checkbox
            label="I consent to marketing communications"
            description="Receive updates about new features, enquiries, and platform improvements (optional)"
            checked={formData?.agreeToMarketing}
            onChange={(e) => onChange({ target: { name: 'agreeToMarketing', value: e?.target?.checked } })}
          />
          
          <Checkbox
            label="I understand the £7.00 enquiry acceptance fee"
            description="I acknowledge that accepting enquiries will incur a £7.00 charge per enquiry"
            checked={formData?.understandFees}
            onChange={(e) => onChange({ target: { name: 'understandFees', value: e?.target?.checked } })}
            error={errors?.understandFees}
            required
          />
        </div>

        <div className="mt-6 p-4 bg-primary/10 border border-primary/20 rounded-lg">
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={20} className="text-primary flex-shrink-0 mt-0.5" />
            <div className="text-sm">
              <p className="font-medium text-foreground mb-1">Next Steps</p>
              <p className="text-muted-foreground">
                After submission, our team will review your application and documents within 2-3 business days. 
                Once approved, you'll set up your payment method in Agent Settings before accepting enquiries.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSetupForm;